var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 80,
    viewBox: "0 0 82 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.44629 39.5548C2.44629 49.7802 6.5083 59.5867 13.7387 66.8172C20.9692 74.0476 30.7757 78.1096 41.0011 78.1096C51.2265 78.1096 61.033 74.0476 68.2635 66.8172C75.4939 59.5867 79.5559 49.7802 79.5559 39.5548C79.5559 29.3294 75.4939 19.5229 68.2635 12.2924C61.033 5.06201 51.2265 1 41.0011 1C30.7757 1 20.9692 5.06201 13.7387 12.2924C6.5083 19.5229 2.44629 29.3294 2.44629 39.5548V39.5548Z",
    fill: "#F7F8FA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12383_17079",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 78,
    height: 78
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.44629 39.5548C2.44629 49.7802 6.5083 59.5867 13.7387 66.8172C20.9692 74.0476 30.7757 78.1096 41.0011 78.1096C51.2265 78.1096 61.033 74.0476 68.2635 66.8172C75.4939 59.5867 79.5559 49.7802 79.5559 39.5548C79.5559 29.3294 75.4939 19.5229 68.2635 12.2924C61.033 5.06201 51.2265 1 41.0011 1C30.7757 1 20.9692 5.06201 13.7387 12.2924C6.5083 19.5229 2.44629 29.3294 2.44629 39.5548V39.5548Z",
    fill: "#F7F8FA"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12383_17079)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.5822 37.9038L84.9333 46.3732C84.9647 46.4864 85.0324 46.5861 85.1259 46.6571C85.2194 46.7281 85.3336 46.7665 85.451 46.7664H86.5479C86.6879 46.7665 86.8223 46.7119 86.9226 46.6142C87.0229 46.5166 87.0811 46.3836 87.0848 46.2437L87.5588 28.7849C87.539 27.9384 87.1869 27.1336 86.5787 26.5445C85.9705 25.9553 85.1549 25.629 84.3082 25.6361L67.3365 25.7877C66.3534 25.7966 65.3916 26.0752 64.556 26.5933L59.8135 29.5351V37.0083C59.8135 37.8635 60.1532 38.6837 60.758 39.2884C61.3627 39.8932 62.1829 40.2329 63.0381 40.2329L68.8119 38.4854C75.3918 41.3055 79.4203 33.8725 82.5822 37.9038Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5822 37.9038L84.9333 46.3733C84.9647 46.4864 85.0324 46.5861 85.1259 46.6571C85.2194 46.7281 85.3336 46.7665 85.451 46.7664H86.5479C86.6879 46.7665 86.8223 46.7119 86.9226 46.6142C87.0229 46.5166 87.0811 46.3836 87.0848 46.2437L87.5588 28.7849C87.539 27.9384 87.1869 27.1336 86.5787 26.5445C85.9705 25.9553 85.1549 25.629 84.3082 25.6361L67.3365 25.7877C66.3534 25.7966 65.3915 26.0752 64.556 26.5933L59.8135 29.5351V37.0083C59.8135 37.8635 60.1532 38.6837 60.758 39.2884C61.3627 39.8932 62.1829 40.2329 63.0381 40.2329L68.8119 38.4854C75.3918 41.3055 79.4203 33.8725 82.5822 37.9038Z",
    stroke: "#0E2032",
    strokeWidth: 0.789192,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6893 37.9033L63.4937 46.28C63.5063 46.413 63.5681 46.5366 63.6669 46.6265C63.7658 46.7164 63.8947 46.7661 64.0284 46.7659H64.8119C64.9454 46.7659 65.0742 46.716 65.173 46.6262C65.2719 46.5364 65.3337 46.4129 65.3465 46.28L66.1487 37.9033",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6893 37.9033L63.4937 46.28C63.5063 46.413 63.5681 46.5366 63.6669 46.6265C63.7658 46.7164 63.8947 46.7661 64.0284 46.7659H64.8119C64.9454 46.7659 65.0742 46.716 65.173 46.6262C65.2719 46.5364 65.3337 46.4129 65.3465 46.28L66.1487 37.9033",
    stroke: "#0E2032",
    strokeWidth: 0.789192,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2504 27.2728C52.2504 27.2728 53.4169 28.8986 54.5427 28.8986C54.994 28.9155 55.4338 28.7546 55.7677 28.4506C56.1016 28.1465 56.3028 27.7236 56.3281 27.2728C56.3281 26.1894 54.1393 25.5812 52.2504 27.2728Z",
    fill: "#808080",
    stroke: "#0E2032",
    strokeWidth: 0.789192,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4384 32.413C57.5769 32.9105 57.8744 33.3489 58.2856 33.6613C58.6968 33.9737 59.199 34.1428 59.7154 34.1428C60.2318 34.1428 60.734 33.9737 61.1452 33.6613C61.5564 33.3489 61.854 32.9105 61.9925 32.413L63.3626 27.4912C63.4338 27.2375 63.4165 26.9671 63.3137 26.7245C63.2109 26.4819 63.0287 26.2814 62.7969 26.1561C61.8615 25.6125 60.799 25.3262 59.7171 25.3262C58.6353 25.3262 57.5727 25.6125 56.6373 26.1561C56.4055 26.2814 56.2232 26.4818 56.1204 26.7244C56.0176 26.9671 56.0004 27.2375 56.0716 27.4912L57.4384 32.413Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2182 28.0111C63.1123 27.8474 62.967 27.713 62.7956 27.6201C61.8602 27.0766 60.7976 26.7902 59.7158 26.7902C58.6339 26.7902 57.5713 27.0766 56.636 27.6201C56.4649 27.7129 56.3198 27.8471 56.2139 28.0105L56.0686 27.4889C55.9232 26.965 56.1574 25.8381 56.6343 25.5801C57.5696 25.0366 58.6322 24.7502 59.7141 24.7502C60.7959 24.7502 61.8585 25.0366 62.7939 25.5801C63.2713 25.8375 63.5067 26.9662 63.3596 27.4889L63.2182 28.0111Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4386 32.4131C57.577 32.9106 57.8746 33.3491 58.2858 33.6614C58.697 33.9738 59.1992 34.1429 59.7156 34.1429C60.232 34.1429 60.7342 33.9738 61.1454 33.6614C61.5566 33.3491 61.8542 32.9106 61.9926 32.4131L63.3628 27.4913C63.5088 26.9686 63.2734 25.84 62.7971 25.5826C61.8617 25.039 60.7991 24.7527 59.7173 24.7527C58.6355 24.7527 57.5729 25.039 56.6375 25.5826C56.1589 25.8406 55.9241 26.9675 56.0718 27.4913L57.4386 32.4131Z",
    stroke: "#0E2032",
    strokeWidth: 0.789192,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2309 32.4748C61.3478 32.6287 61.4194 32.8121 61.4377 33.0045C61.456 33.1968 61.4203 33.3905 61.3345 33.5636C61.2487 33.7367 61.1163 33.8825 60.9522 33.9845C60.7881 34.0865 60.5988 34.1406 60.4055 34.1409H59.0252C58.8316 34.1409 58.6418 34.0869 58.4773 33.9848C58.3128 33.8827 58.1801 33.7366 58.0942 33.5631C58.0084 33.3896 57.9728 33.1955 57.9914 33.0028C58.0101 32.8101 58.0822 32.6264 58.1998 32.4725L58.2196 32.4471C58.3972 32.2206 58.624 32.0374 58.8828 31.9114C59.1417 31.7854 59.4258 31.72 59.7136 31.72C60.0015 31.72 60.2856 31.7854 60.5445 31.9114C60.8033 32.0374 61.0301 32.2206 61.2077 32.4471L61.2309 32.4748Z",
    fill: "#FFA694",
    stroke: "#0E2032",
    strokeWidth: 0.789192,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6416 28.1101C61.6416 28.2644 61.5803 28.4123 61.4713 28.5214C61.3622 28.6304 61.2143 28.6917 61.06 28.6917C60.9058 28.6917 60.7579 28.6304 60.6488 28.5214C60.5397 28.4123 60.4785 28.2644 60.4785 28.1101C60.4785 27.9559 60.5397 27.808 60.6488 27.6989C60.7579 27.5898 60.9058 27.5286 61.06 27.5286C61.2143 27.5286 61.3622 27.5898 61.4713 27.6989C61.5803 27.808 61.6416 27.9559 61.6416 28.1101Z",
    fill: "#0E2032"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9854 28.1101C58.9854 28.2644 58.9241 28.4123 58.815 28.5214C58.706 28.6304 58.558 28.6917 58.4038 28.6917C58.2495 28.6917 58.1016 28.6304 57.9926 28.5214C57.8835 28.4123 57.8222 28.2644 57.8222 28.1101C57.8222 27.9559 57.8835 27.808 57.9926 27.6989C58.1016 27.5898 58.2495 27.5286 58.4038 27.5286C58.558 27.5286 58.706 27.5898 58.815 27.6989C58.9241 27.808 58.9854 27.9559 58.9854 28.1101V28.1101Z",
    fill: "#0E2032"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3174 32.7737V33.2466",
    stroke: "#0E2032",
    strokeWidth: 0.789192,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2075 32.7737V33.2466",
    stroke: "#0E2032",
    strokeWidth: 0.789192,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1799 27.2728C67.1799 27.2728 66.0134 28.8986 64.8876 28.8986C64.4364 28.9154 63.9966 28.7544 63.6628 28.4504C63.3289 28.1464 63.1277 27.7236 63.1022 27.2728C63.1022 26.1894 65.291 25.5812 67.1799 27.2728Z",
    fill: "#808080",
    stroke: "#0E2032",
    strokeWidth: 0.789192,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.062 39.6317L82.5823 37.9034C80.6418 35.4295 78.3756 37.2727 75.3931 38.4126C75.8856 39.123 76.5464 39.7004 77.3163 40.0935C78.0862 40.4866 78.9414 40.683 79.8057 40.6653C80.9733 40.6749 82.1137 40.313 83.062 39.6317V39.6317Z",
    fill: "#FFCCDD",
    stroke: "#0E2032",
    strokeWidth: 0.789192,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6379 56.0009C76.8926 54.0285 77.8532 51.9548 78.5016 49.8188L77.4073 49.182C73.6953 47.1277 69.2318 46.015 64.6467 46.0009C60.0615 45.9867 55.5863 47.0718 51.8527 49.1031L39.751 56.0009H75.6379Z",
    fill: "#F7CA50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5016 49.8188L77.4073 49.182C73.6953 47.1277 69.2318 46.015 64.6467 46.0009C60.0615 45.9867 55.5863 47.0718 51.8527 49.1031L39.751 56.0009",
    stroke: "#0E2032",
    strokeWidth: 0.789192,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.10372 43.9045L3.15186 46.9117C3.7861 50.2036 4.85 53.3979 6.31624 56.4126H59.8216L42.8797 43.7541C32.6473 36.1116 17.2494 36.1742 7.10372 43.9045Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8216 56.4078L42.8797 43.7541C32.6473 36.1116 17.2494 36.1742 7.10372 43.9045L3.15186 46.9117",
    stroke: "#0E2032",
    strokeWidth: 0.789192,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0654 12.0282V10.5188",
    stroke: "#0E2032",
    strokeWidth: 0.789192,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6642 14.6822L21.5962 13.6143",
    stroke: "#0E2032",
    strokeWidth: 0.789192,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0094 21.0859H18.5",
    stroke: "#0E2032",
    strokeWidth: 0.789192,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6642 27.4907L21.5962 28.5587",
    stroke: "#0E2032",
    strokeWidth: 0.789192,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9766 14.6822L37.0436 13.6143",
    stroke: "#0E2032",
    strokeWidth: 0.789192,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6299 21.0859H40.1403",
    stroke: "#0E2032",
    strokeWidth: 0.789192,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9766 27.4907L37.0436 28.5587",
    stroke: "#0E2032",
    strokeWidth: 0.789192,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0654 30.146V31.6554",
    stroke: "#0E2032",
    strokeWidth: 0.789192,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22.022 21.0872C22.022 22.9556 22.7642 24.7475 24.0854 26.0687C25.4066 27.3899 27.1985 28.1321 29.0669 28.1321C30.9353 28.1321 32.7272 27.3899 34.0484 26.0687C35.3696 24.7475 36.1118 22.9556 36.1118 21.0872C36.1118 19.2187 35.3696 17.4268 34.0484 16.1056C32.7272 14.7845 30.9353 14.0422 29.0669 14.0422C27.1985 14.0422 25.4066 14.7845 24.0854 16.1056C22.7642 17.4268 22.022 19.2187 22.022 21.0872V21.0872Z",
    fill: "white",
    stroke: "#0E2032",
    strokeWidth: 0.789192,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5903 56.4077H81",
    stroke: "#0E2032",
    strokeWidth: 0.789192,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1 56.4077H3.40968",
    stroke: "#0E2032",
    strokeWidth: 0.789192,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2189 56.4077H5.7793C8.96044 63.0504 13.9553 68.6579 20.1872 72.5832C26.4191 76.5084 33.634 78.5913 40.9991 78.5913C48.3642 78.5913 55.5791 76.5084 61.811 72.5832C68.043 68.6579 73.0378 63.0504 76.2189 56.4077Z",
    fill: "#F7CA50"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6648 56.4077H5.33838",
    stroke: "#0E2032",
    strokeWidth: 0.789192,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6833 56.4077H6.31738",
    stroke: "#0E2032",
    strokeWidth: 0.789192,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6128 54.8313V60.0689",
    stroke: "#0E2032",
    strokeWidth: 0.789192,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6121 60.0691C14.6886 60.8151 16.1566 63.7871 14.5723 64.5164",
    stroke: "#0E2032",
    strokeWidth: 0.789192,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7761 61.6343C15.4893 61.9796 15.1348 62.2627 14.7346 62.466C14.3344 62.6694 13.8968 62.7888 13.4487 62.8169",
    stroke: "#0E2032",
    strokeWidth: 0.789192,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6128 60.0691C20.5363 60.8151 19.4292 63.1419 21.0136 63.8729",
    stroke: "#0E2032",
    strokeWidth: 0.789192,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8132 61.9707C19.4751 62.3882 19.2905 62.9092 19.2905 63.4465C19.2905 63.9838 19.4751 64.5048 19.8132 64.9223",
    stroke: "#0E2032",
    strokeWidth: 0.789192,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M17.611 60.0691C17.611 60.0691 16.9639 61.5683 17.5258 62.7299C18.0877 63.8915 17.611 65.8219 17.611 65.8219",
    stroke: "#0E2032",
    strokeWidth: 0.789192,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7569 63.5352C17.3943 64.1053 16.871 64.5554 16.2529 64.8287",
    stroke: "#0E2032",
    strokeWidth: 0.789192,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0257 47.3232C23.0257 47.3232 24.0889 50.5471 22.6413 52.4655C21.8455 53.5192 20.2684 53.7135 19.4678 52.0368C17.6357 51.7267 17.3209 49.7538 18.3931 48.9832C19.5913 48.1208 21.1145 49.3268 23.0257 47.3232Z",
    fill: "#F7CA50"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M9.95888 44.7507C9.95888 44.7507 9.03777 48.8718 11.0641 51.0684C12.1777 52.2756 14.1549 52.3224 14.9399 50.1491C17.1689 49.541 17.317 47.0607 15.8958 46.2374C14.3072 45.3174 12.5699 46.9966 9.95888 44.7507Z",
    fill: "#F7CA50"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5191 50.023C19.1653 51.6589 17.6121 54.8312 17.6121 54.8312C17.6121 54.8312 16.622 49.7147 12.1802 48.095",
    stroke: "#0E2032",
    strokeWidth: 0.789192,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M9.95888 44.7507C9.95888 44.7507 9.03777 48.8718 11.0641 51.0684C12.1777 52.2756 14.1549 52.3224 14.9399 50.1491C17.1689 49.541 17.317 47.0607 15.8958 46.2374C14.3072 45.3174 12.5699 46.9966 9.95888 44.7507Z",
    stroke: "#0E2032",
    strokeWidth: 0.789192,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0257 47.3232C23.0257 47.3232 24.0889 50.5471 22.6413 52.4655C21.8455 53.5192 20.2684 53.7135 19.4678 52.0368C17.6357 51.7267 17.3209 49.7538 18.3931 48.9832C19.5913 48.1208 21.1145 49.3268 23.0257 47.3232Z",
    stroke: "#0E2032",
    strokeWidth: 0.789192,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7559 54.8313V60.0689",
    stroke: "#0E2032",
    strokeWidth: 0.789192,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7546 60.0691C32.8312 60.8151 34.2992 63.7871 32.7148 64.5164",
    stroke: "#0E2032",
    strokeWidth: 0.789192,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9182 61.6343C33.6313 61.9796 33.2769 62.2627 32.8767 62.466C32.4765 62.6694 32.0389 62.7888 31.5908 62.8169",
    stroke: "#0E2032",
    strokeWidth: 0.789192,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7559 60.0691C38.6793 60.8151 37.5723 63.1419 39.1567 63.8729",
    stroke: "#0E2032",
    strokeWidth: 0.789192,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9553 61.9707C37.6171 62.3882 37.4326 62.9092 37.4326 63.4465C37.4326 63.9838 37.6171 64.5048 37.9553 64.9223",
    stroke: "#0E2032",
    strokeWidth: 0.789192,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M35.754 60.0691C35.754 60.0691 35.107 61.5683 35.6689 62.7299C36.2308 63.8915 35.754 65.8219 35.754 65.8219",
    stroke: "#0E2032",
    strokeWidth: 0.789192,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9 63.5352C35.5373 64.1053 35.014 64.5554 34.396 64.8287",
    stroke: "#0E2032",
    strokeWidth: 0.789192,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1683 47.3232C41.1683 47.3232 42.2315 50.5471 40.7839 52.4655C39.9881 53.5192 38.4109 53.7135 37.6104 52.0368C35.7783 51.7267 35.4635 49.7538 36.5357 48.9832C37.7339 48.1208 39.2571 49.3268 41.1683 47.3232Z",
    fill: "#F7CA50"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1019 44.7507C28.1019 44.7507 27.1808 48.8718 29.2072 51.0684C30.3208 52.2756 32.2979 52.3224 33.0829 50.1491C35.312 49.541 35.4601 47.0607 34.0388 46.2374C32.4503 45.3174 30.713 46.9966 28.1019 44.7507Z",
    fill: "#F7CA50"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6621 50.023C37.3084 51.6589 35.7552 54.8312 35.7552 54.8312C35.7552 54.8312 34.7651 49.7147 30.3232 48.095",
    stroke: "#0E2032",
    strokeWidth: 0.789192,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1019 44.7507C28.1019 44.7507 27.1808 48.8718 29.2072 51.0684C30.3208 52.2756 32.2979 52.3224 33.0829 50.1491C35.312 49.541 35.4601 47.0607 34.0388 46.2374C32.4503 45.3174 30.713 46.9966 28.1019 44.7507Z",
    stroke: "#0E2032",
    strokeWidth: 0.789192,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1683 47.3232C41.1683 47.3232 42.2315 50.5471 40.7839 52.4655C39.9881 53.5192 38.4109 53.7135 37.6104 52.0368C35.7783 51.7267 35.4635 49.7538 36.5357 48.9832C37.7339 48.1208 39.2571 49.3268 41.1683 47.3232Z",
    stroke: "#0E2032",
    strokeWidth: 0.789192,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcl);
export default __webpack_public_path__ + "static/media/icl.eedefa9c6a4a0371780a8877773a636e.svg";
export { ForwardRef as ReactComponent };